/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(event) {
        if (event.target.classList.contains('readmore')) {
            event.preventDefault();
            var descriptionFull = document.querySelector('.product-description-full');
            if (descriptionFull) {
                descriptionFull.style.display = 'block';
            }
            var descriptionShort = document.querySelector('.product-description-short');
            if (descriptionShort) {
                descriptionShort.style.display = 'none';
            }
        } else if (event.target.classList.contains('readless')) {
            event.preventDefault();
            var descriptionFull = document.querySelector('.product-description-full');
            if (descriptionFull) {
                descriptionFull.style.display = 'none';
            }
            var descriptionShort = document.querySelector('.product-description-short');
            if (descriptionShort) {
                descriptionShort.style.display = 'block';
            }
            /*window.scrollTo({top: 110, behavior: 'smooth'});*/
        }
    });
});
